export function formatCurrency(value, country) {
	if (country === 'MEXICO') {
		return `+MXN $${value}`;
	}
	if (country === 'COLOMBIA') {
		return `+COP $${value}`;
	}
	if (country === 'BRASIL') {
		return `+BRL $${value}`;
	}
	return `+ARS $${value}`;
}

export function getCurrency(country) {
	if (country === 'MEXICO') {
		return 'MXN';
	}
	if (country === 'COLOMBIA') {
		return 'COP';
	}
	if (country === 'BRASIL') {
		return 'BRL';
	}
	return 'ARS';
}
